import type { ClientDiagnosticEvent } from './generated';

import { apiClient } from './client';

export type ClientDiagnosticDelivery = (
  event: ClientDiagnosticEvent,
) => Promise<unknown>;

const deliverClientDiagnostic: ClientDiagnosticDelivery = (event) =>
  apiClient.post<void>('/diagnostics/client-events', { json: event });

/**
 * Starts a best-effort diagnostic delivery without delaying the observed browser action.
 * Both synchronous transport failures and rejected requests are deliberately ignored.
 */
export function reportClientDiagnostic(
  event: ClientDiagnosticEvent,
  delivery: ClientDiagnosticDelivery = deliverClientDiagnostic,
): void {
  try {
    void delivery(event).catch(() => undefined);
  } catch {
    // Diagnostics must never break or delay the user action they describe.
  }
}
